/**
 * Medbook
 * Medbook api
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export interface ProcedureDisciplineFields { 
    /**
     * 
     */
    "pediatric-urology"?: ProcedureDisciplineFields.PediatricUrologyEnum;
    /**
     * 
     */
    "functional-reconstructive-urology-andrology"?: ProcedureDisciplineFields.FunctionalReconstructiveUrologyAndrologyEnum;
    /**
     * 
     */
    endourology?: ProcedureDisciplineFields.EndourologyEnum;
    /**
     * 
     */
    "laparoscopic-robotic-surgery"?: ProcedureDisciplineFields.LaparoscopicRoboticSurgeryEnum;
}
export namespace ProcedureDisciplineFields {
    export type PediatricUrologyEnum = 'J' | 'N';
    export const PediatricUrologyEnum = {
        J: 'J' as PediatricUrologyEnum,
        N: 'N' as PediatricUrologyEnum
    };
    export type FunctionalReconstructiveUrologyAndrologyEnum = 'J' | 'N';
    export const FunctionalReconstructiveUrologyAndrologyEnum = {
        J: 'J' as FunctionalReconstructiveUrologyAndrologyEnum,
        N: 'N' as FunctionalReconstructiveUrologyAndrologyEnum
    };
    export type EndourologyEnum = 'J' | 'N';
    export const EndourologyEnum = {
        J: 'J' as EndourologyEnum,
        N: 'N' as EndourologyEnum
    };
    export type LaparoscopicRoboticSurgeryEnum = 'J' | 'N';
    export const LaparoscopicRoboticSurgeryEnum = {
        J: 'J' as LaparoscopicRoboticSurgeryEnum,
        N: 'N' as LaparoscopicRoboticSurgeryEnum
    };
}


